export const ROOT_URL = '/';
export const AUTO_LOGIN_URL = '/auto-login';

export const CAMPAIGNS_URL = '/campaigns';
export const ADD_CAMPAIGN_URL = '/campaigns/create-campaign';
export const EDIT_CAMPAIGN_URL = '/campaigns/create-campaign/:campaignId?/';
export const CM_ROI_DASHBOARD_URL = '/campaigns/:campaignId?/dashboard/:tabName?';
export const CM_PERSONA_DETAILS =
  '/campaigns/:campaignId?/dashboard/audiences/details/:requestId?/:personaId?';
export const CM_INFLUENCER_LIST =
  '/campaigns/:campaignId?/dashboard/audiences/details/:requestId?/:personaId?/influencers';
export const CM_INFLUENCER_LIST_DETAILS =
  '/campaigns/:campaignId?/dashboard/audiences/details/:requestId?/:personaId?/influencers/:influencerId?/:reportId?';
export const CM_INFLUENCER_CONTENT_DETAILS =
  '/content-analysis/details/:creatorReportDetailsId?/:creatorPostId?';
export const CM_INFLUENCER_COMPARE =
  '/campaigns/:campaignId?/audiences/details/:requestId?/:personaId?/influencers/compare/:compareArray?';
export const CM_PERSONA_COMPARE =
  '/campaigns/:campaignId?/dashboard/audiences/compare/:audienceIdArray?';
// Audience Engine URLs - DEPRECATED
export const PE_URL_INFLUENCER_COMPARE =
  '/persona/details/:requestId?/:personaId?/influencers/compare';
// Media Ranking Model
export const MRM_LIBRARY_URL = '/media/library/:requestId?/:segmentId?'; // segmentId = personaId
export const MRM_LIBRARY_DEFAULT_URL = '/media/library'; // universal persona
export const MRM_UPLOAD_URL = '/media/upload/:requestId?/:segmentId?'; // segmentId = personaId
export const MRM_UPLOAD_DEFAULT_URL = '/media/upload';
export const MRM_DETAILS_URL = '/media/details/:mediaId?';
export const CONTENT_STUDIO_URL = '/media/content-studio'; // Creative Intelligence › Content Studio (coming soon)
// ECommerce
export const ECOMMERCE_MAIN_URL = '/influencer-discovery/social-commerce';
export const SOCIAL_COMMERCE_DEFAULT_URL = '/social-commerce/influencer';
export const SOCIAL_COMMERCE_SHOPS_URL = '/social-commerce/seller';
export const SOCIAL_COMMERCE_PRODUCT_URL = '/social-commerce/product';
export const SOCIAL_COMMERCE_LIVE_URL = '/social-commerce/live';
export const SOCIAL_COMMERCE_VIDEO_URL = '/social-commerce/video';
export const ECOMMERCE_INFLUENCER_DETAILS_URL = '/social-commerce/influencer/details/:user_id?';
export const ECOMMERCE_PRODUCT_DETAILS_URL = '/social-commerce/product/details/:productId?';
export const ECOMMERCE_VIDEO_DETAILS_URL = '/social-commerce/video/details/:videoId?';
export const ECOMMERCE_SELLER_DETAILS_URL = '/social-commerce/seller/details/:seller_id?';
export const ECOMMERCE_LIVE_DETAILS_URL = '/social-commerce/live/details/:room_id?';
// Universal List
export const UNIVERSAL_INFLUENCER_LIST = '/universal/influencerList';
export const UNIVERSAL_INFLUENCER_REPORT =
  '/universal/influencerList/influencerReport/:universalListId?/:socialNetwork?/:username?/';
export const UNIVERSAL_DISCOVERY_INFLUENCER_REPORT_URL =
  '/universal-discovery/influencer-report/:universalListId?/:socialNetwork?/:username?/';
// Competitive Intel
export const COMPETITIVE_INTEL_DEFAULT_URL = '/competitive-intel';
export const COMPETITIVE_INTEL_OVERVIEW_URL = '/competitive-intel/dashboard/overview/:requestId?';
export const COMPETITIVE_INTEL_BUYING_MOTIVATIONS_URL =
  '/competitive-intel/dashboard/buying-motivations/:requestId?';
export const COMPETITIVE_INTEL_PAIN_POINTS_URL =
  '/competitive-intel/dashboard/pain-points/:requestId?';
// Workspace
export const WORKSPACE_MEMBERS_URL = '/workspace/members';
export const WORKSPACE_DASHBOARD_PLAN_URL = '/workspace/plan';
export const WORKSPACE_SETTINGS_URL = '/workspace/settings';
// Audience
export const AUDIENCES_INDEX_URL = '/audiences';
export const AUDIENCES_CREATE_URL = '/audiences/create';
export const AUDIENCES_DETAIL_URL = '/audiences/:audienceId';
export const AUDIENCES_SEGMENT_DETAILS_URL = '/audiences/details/:personaId/:requestId';
export const AUDIENCES_SEGMENT_INFLUENCERS_URL =
  '/audiences/details/:personaId/:requestId/influencers';
export const AUDIENCES_SEGMENT_INFLUENCER_REPORT_URL =
  '/audiences/details/:personaId/:requestId/influencers/:platform/:username';

// Brand Safety
// Deliberately top-level rather than nested under a campaign dashboard: the report owns its own
// breadcrumb and header centre control, and CampaignDashboard already occupies HeaderPrefixSlot.
// `platform` + `username` are the only identifiers every calling table carries; the remaining ids
// (campaignId, crd, requestId) and the breadcrumb `source` ride in the query string.
// Build URLs with buildBrandSafetyReportUrl() from BrandSafety/utils/brandSafetyBreadcrumbs.
export const BRAND_SAFETY_REPORT_URL = '/brand-safety/:platform/:username';
// Same report page, nested under the Persona influencer list's own path instead. Used only for the
// INFLUENCER_LIST source, so requestId/personaId ride along in the URL itself — otherwise the
// "Influencers List" breadcrumb crumb has no way to link back to a working CM_INFLUENCER_LIST URL.
// Must be registered (BasePage.js) ahead of the CM_ROI_DASHBOARD_URL catch-all, same as
// CM_INFLUENCER_LIST_DETAILS, so it still renders standalone rather than nested under CampaignDashboard.
export const CM_INFLUENCER_LIST_BRAND_SAFETY_REPORT =
  '/campaigns/:campaignId?/dashboard/audiences/details/:requestId?/:personaId?/influencers/brand-safety/:platform?/:username?';

export const LOGOUT_URL = '/logout';
export const SIGNUP_URL = '/signup';

export const WORKSPACE_REQUEST_TO_JOIN_EMAIL_QUERY = 'email';
export const WORKSPACE_REQUEST_TO_JOIN_CODE_QUERY = 'code';
export const WORKSPACE_REQUEST_TO_JOIN_DOMAIN_EXISTED_QUERY = 'domainExisted';

export function buildWorkspaceRequestToJoinSignupUrl(email, code, options = {}) {
  const { domainExisted = false } = options;
  const e = encodeURIComponent(String(email ?? '').trim());
  const c = encodeURIComponent(String(code ?? '').trim());
  let url = `${SIGNUP_URL}?${WORKSPACE_REQUEST_TO_JOIN_EMAIL_QUERY}=${e}&${WORKSPACE_REQUEST_TO_JOIN_CODE_QUERY}=${c}`;
  if (domainExisted) {
    url += `&${WORKSPACE_REQUEST_TO_JOIN_DOMAIN_EXISTED_QUERY}=1`;
  }
  return url;
}

export const WORKSPACE_INVITE_SIGNUP_ROUTE = '/:workspaceSlug/invite/:invitationToken';
export const WORKSPACE_DECLINE = '/:workspaceSlug/invite/:invitationToken/decline';
export const SETTINGS_URL = '/settings';
export const SETTINGS_BILLING_URL = '/settings?to=billing';
export const SETTINGS_PROFILE_URL = '/settings/profile';
export const SETTINGS_INTEGRATIONS_URL = '/settings/integrations';
export const SETTINGS_MANAGE_SUB_ACCOUNTS_URL = '/settings/manageSubAccounts';
export const SETTINGS_MANAGE_CLOSE_ACCOUNT_URL = '/settings/closeAccount';

export const FORGOT_PASSWORD_URL = '/forgot-password';
export const RECOVER_PASSWORD_URL = '/recover-password';
export const EDITOR_URL = '/:contentType/editor/:contentId?/:integrationType?/';
export const ERROR404 = '/error/404';
export const ERROR500 = '/error/500';

export const ACCOUNT_EXPIRED = '/accountExpired';

export const TIKTOK_OAUTH_URL = '/oauth/tiktok_h';
export const TIKTOK_OAUTH_URL_ADS = '/oauth/tiktok_ad';
export const DOCUSIGN_AUTH_URL = '/auth/docusign';
export const GOOGLE_DOCS_URL = '/googledoc/sign';

export const HOMEPAGE_URL = CAMPAIGNS_URL;

export const OUTREACH_CONTENT_REVISION_DETAILS_URL =
  '/content-revisions/:hash?/deliverable/:revisionDetailsId?';
export const OUTREACH_CONTENT_REVISION_LIST_URL = '/content-revisions/:hash?';
export const OUTREACH_CONTENT_REVISION_ANALYSIS_INF_URL =
  '/content-revisions/analysis/:revisionConvId?';
export const OUTREACH_CONTENT_REVISION_ANALYSIS_CLIENT_URL =
  '/content-revisions/details/:revisionConvId?';

export const OUTLOOK_AUTH_REDIRECT_URL = '/outlook-mailer-callback';

export const GMAIL_OAUTH_CALLBACK_URL = '/oauth/gmail/callback';

export const INFLUENCER_LIST_NONAUTH =
  '/audiences/:requestId?/:personaId?/influencers/:magicLinkId?/:hashCode?';

export const INFLUENCER_DETAILS_NONAUTH =
  '/audiences/:requestId?/:personaId?/influencers/:magicLinkId?/:hashCode?/details/:reportId?';

export const INFLUENCER_COMPARE_NONAUTH =
  '/audiences/:requestId?/:personaId?/influencers/:magicLinkId?/:hashCode?/compare/:compareArray?';

// new nav route design
export const UNIVERSAL_DISCOVERY_URL = '/universal-discovery';
export const UNIVERSAL_DISCOVERY_DETAILS_URL = '/universal-discovery/details/:discoveryId?';
export const CAMPAIGN_DASHBOARD_OVERVIEW_URL = '/campaigns/:campaignId?/dashboard/overview';
export const CAMPAIGN_DASHBOARD_PERFORMANCE_URL = '/campaigns/:campaignId?/dashboard/performance';
export const CAMPAIGN_DASHBOARD_INFLUENCERS_URL =
  '/campaigns/:campaignId?/dashboard/collaborations';
export const OUTREACH_INFLUENCERS_URL =
  '/campaigns/:campaignId?/dashboard/collaborations/influencers';
export const OUTREACH_MESSAGE_CENTER_URL =
  '/campaigns/:campaignId?/dashboard/collaborations/message-center';
export const OUTREACH_DOCUMENTS_URL = '/campaigns/:campaignId?/dashboard/collaborations/documents';
export const OUTREACH_DELIVERABLES_URL =
  '/campaigns/:campaignId?/dashboard/collaborations/deliverables';
export const OUTREACH_DELIVERABLE_DETAILS_URL =
  '/campaigns/:campaignId?/dashboard/collaborations/deliverables/:contentRevisionDetailsId';
export const CAMPAIGN_DASHBOARD_AUDIENCES_URL = '/campaigns/:campaignId?/dashboard/audiences';
export const CAMPAIGN_DASHBOARD_CONTENT_RANKING_URL =
  '/campaigns/:campaignId?/dashboard/content-ranking';
export const CAMPAIGN_DASHBOARD_BRAND_SAFETY_URL = '/campaigns/:campaignId?/dashboard/brand-safety';
export const AUDIENCE_CREATE_URL = '/campaigns/:campaignId?/dashboard/audiences/create';
// support urls
export const SUPPORT_URL = '/support';
export const SUPPORT_CONTACT_URL = '/support/contact';
export const SUPPORT_EMAIL_URL = '/support/email';

export const REQUIRE_AUTH = [
  CAMPAIGNS_URL,
  EDITOR_URL,
  SETTINGS_URL,
  FORGOT_PASSWORD_URL,
  RECOVER_PASSWORD_URL,
];
